import * as Actions from "./actions";
import * as Mutations from "./mutations";

const DEFAULT_VALUES = {
  filter: "mine",
  order: "updated_at",
  orderDirection: "desc",
  filterKeyword: "",
};

const datahubLayers = {
  namespaced: true,
  state: {
    isFetching: false,
    isFiltered: false,
    isErrored: false,
    error: {},
    filterType: DEFAULT_VALUES.filter,
    filterKeyword: DEFAULT_VALUES.filterKeyword,
    order: DEFAULT_VALUES.order,
    orderDirection: DEFAULT_VALUES.orderDirection,
    addedList: [],
    list: [],
    metadata: {},
    page: 1,
    numPages: 1,
    resultsPerPage: 12,
  },
  getters: {
  },
  actions: {
    filter: Actions.filter,
    fetch: Actions.fetch,
    addToEarth: Actions.addToEarth,
    removeFromEarth: Actions.removeFromEarth,
    setPagination: Actions.setPagination,
    order: Actions.order,
    resetFilters: Actions.resetFilters,
    setResultsPerPage: Actions.setResultsPerPage,
    updateVisualization: Actions.updateVisualization,
  },
  mutations: {
    setFetchingState: Mutations.setFetchingState,
    setFilterType: Mutations.setFilterType,
    setFilterKeyword: Mutations.setFilterKeyword,
    setPagination: Mutations.setPagination,
    setLayers: Mutations.setLayers,
    updateVisualization: Mutations.updateVisualization,
    setRequestError: Mutations.setRequestError,
    addToEarth: Mutations.addToEarth,
    removeFromEarth: Mutations.removeFromEarth,
  },
};
export default datahubLayers;
